import React, { useEffect, useState } from 'react';
import { TableStriped } from '../tables/TableStriped';
import { useHistory } from 'react-router';
import { Button, Collapse, Form, ModalBody, ModalHeader, FormGroup, Label, Row, Col, Input, ListGroupItem, ListGroup, Table } from 'reactstrap';
import { sendRequest } from '../../hooks/requests/useRequest';
import { validarSesion } from '../../hooks/tokens/useToken';
import { Paginator } from 'primereact/paginator';

export const ModalComplex = (props) => {
    const { history } = useHistory();
    const {
        analytesAvailables, refreshFormComplex, responseComplexText, refreshResultComplex, preSavedFormComplex, analytesComplex, exam, methodActive, name
    } = props;

    const [typeComplex, setTypeComplex] = useState("local");
    const [arrayLocalInputs, setArrayLocalInputs] = useState([]);
    const [localAnalytes, setLocalAnalytes] = useState([]);
    const [valuesLocal, setValuesLocal] = useState({});
    const [formula, setFormula] = useState("");
    const [validacionFormula, setValidacionFormula] = useState({
        status: false,
        msg: ""
    });
    const [examActiveId, setExamActiveId] = useState(exam.id_exam);
    const [externalAnalytes, setExternalAnalytes] = useState([]);
    const [search, setSearch] = useState("");
    const [localExams, setLocalExams] = useState([]);
    const [exams, setExams] = useState([]);

    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);

    const changeType = (type) => {
        setTypeComplex(type);
    }

    const handleInputLocal = ({ target }, tipoDato) => {
        setValuesLocal({
            ...valuesLocal,
            [target.name]: {
                ...valuesLocal[target.name],
                [tipoDato]: target.value.toLowerCase(),
            }
        });
    }

    const validarVariables = ({ target }) => {
        let arrayAux = valuesLocal;
        let validacion = true;
        let validacionNombre = true;
        let validacionValor = true;
        Object.keys(arrayAux).forEach(function (key) {
            if (key !== target.name && arrayAux[key].variable === target.value) {
                validacion = false;
            }

            if (arrayAux[key].variable.trim().length <= 0) {
                validacionNombre = false;
            }
            if (parseFloat(arrayAux[key].valor) === 0 || isNaN(parseFloat(arrayAux[key].valor))) {
                validacionValor = false;
            }
        });
        if (validacionNombre) {
            if (validacion) {
                if (validacionValor) {
                    setValidacionFormula({
                        status: true,
                        msg: ""
                    });
                } else {
                    setValidacionFormula({
                        status: false,
                        msg: "Los valores de prueba no pueden quedarse en 0, se debe asignar un valor mayor o menor a 0."
                    })
                }
            } else {
                setValidacionFormula({
                    status: false,
                    msg: "Existen variables repetidas, es necesario que cada variable sea única."
                })
            }
        } else {
            setValidacionFormula({
                status: false,
                msg: "No se pueden quedar vacios los campos de variable."
            })
        }
    }

    const validarVariablesLocales = () => {
        refreshResultComplex();
        let validacion = true;
        let validacionValor = true;
        if (validacionFormula.status === false) {
            return;
        }
        if (valuesLocal.length <= 0) {
            setValidacionFormula({
                status: false,
                msg: "No se pueden quedar vacios los campos de variable."
            })
        } else {
            Object.keys(valuesLocal).forEach(function (key) {
                if (valuesLocal[key].variable.trim().length <= 0) {
                    validacion = false;
                }

                if (parseFloat(valuesLocal[key].valor) === 0) {
                    validacionValor = false;
                }
            })

            if (validacion) {
                if (validacionValor) {

                    setValidacionFormula({
                        status: true,
                        msg: ""
                    })
                } else {
                    setValidacionFormula({
                        status: false,
                        msg: "Los valores de prueba no pueden quedarse en 0, se debe asignar un valor mayor o menor a 0."
                    })
                }
            } else {
                setValidacionFormula({
                    status: false,
                    msg: "No se pueden quedar vacios los campos de variable."
                })
            }
        }
    }

    const addLocalInput = (id) => {
        let arrayAux = arrayLocalInputs;
        let analyte = null;
        let name_code = "";
        let name = "";
        let code = "";
        let variable = "";
        if (typeComplex === "local") {
            analyte = localAnalytes.find(a => a.id_analyte === parseInt(id));
            let newLocalAnalytes = localAnalytes.filter(la => la.id_analyte !== analyte.id_analyte);
            setLocalAnalytes(newLocalAnalytes);
            name_code = exam.abbreviation + "→" + analyte.code;
            name = analyte.name;
            code = analyte.code;
            variable = exam.abbreviation.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() + "_" + analyte.code.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        } else {
            analyte = externalAnalytes.find(a => a.id_analyte === parseInt(id));
            let newExternalAnalytes = externalAnalytes.filter(la => la.id_analyte !== analyte.id_analyte);
            setExternalAnalytes(newExternalAnalytes);
            let exam = exams.find(e => e.id_exam === parseInt(examActiveId));
            name_code = exam.code + "→" + analyte.code;
            name = analyte.name;
            code = analyte.code;
            variable = exam.abbreviation.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() + "_" + analyte.code.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        }

        let obj = {
            id_analyte: analyte.id_analyte,
            name_code: name_code,
            name: name,
            code: code,
            variable: variable
        }
        setValuesLocal({
            ...valuesLocal,
            [`${obj.id_analyte}`]: {
                id_analyte: obj.id_analyte,
                variable: variable,
                valor: 1
            }
        });
        setValidacionFormula({
            status: true,
            msg: ""
        });
        refreshResultComplex();
        setArrayLocalInputs([...arrayAux, obj]);
    }

    const removeLocalInput = (id) => {
        let arrayAux = arrayLocalInputs.filter(obj => {
            if (obj.id_analyte !== parseInt(id)) {
                return obj;
            }
            return false;
        });
        let newValues = valuesLocal;
        delete newValues[id];
        setValuesLocal(newValues);
        setArrayLocalInputs([...arrayAux]);

        analytesAvailables.forEach(function (element) {
            if (element.id_analyte === id) {
                setLocalAnalytes([...localAnalytes, element]);
            }
        });


        if (typeComplex === "externo") {
            getAnalytesAvailableFromExam(examActiveId, id);
        }

    }

    const handleExternal = (id_exam) => {
        changeType("externo")
        getAnalytesAvailableFromExam(id_exam);
    }

    const handleLocal = (id_exam) => {
        changeType("local")
        setExamActiveId(id_exam);
    }

    const getExams = async() => {
        let requestOptions = {
            method: 'GET',
        };

        const respuesta = await sendRequest(requestOptions, "Exam/List?EnablePagination=false");

        if (respuesta.code === 200) {
            let examenes = respuesta.data.results;
            setExams(examenes);
        }
    }

    const getAnalytesAvailableFromExam = async (id_exam, id_analyte_aux = 0) => {
        let requestOptions = {
            method: 'GET',
        };

        const respuesta = await sendRequest(requestOptions, "Exam/GetAnalytesAvailableFromExam/" + id_exam);

        if (respuesta.code === 200) {
            setExamActiveId(parseInt(id_exam));
            ////console.log(respuesta.data);
            let analytes = respuesta.data;
            arrayLocalInputs.forEach(({ id_analyte }) => {
                if (id_analyte_aux !== id_analyte) {
                    analytes = analytes.filter(a => a.id_analyte !== id_analyte);
                }
            });
            ////console.log("Exteros");
            ////console.log(analytes);
            setExternalAnalytes(analytes);
        }
        else {
            validarSesion(history, respuesta.code, getAnalytesAvailableFromExam);
        }
    }

    const handleSearch = ({ target }) => {
        setSearch(target.value);
        let newExams = exams.filter(function (obj) {
            if (obj.name.toLowerCase().includes(target.value)) {
                return obj;
            }
            return false;
        });
        setLocalExams(newExams);
    }

    useEffect(() => {
        getExams()
    }, [])

    useEffect(() => {
        setLocalAnalytes(analytesAvailables);
    }, [analytesAvailables])

    useEffect(() => {
        if (typeof (analytesComplex) === "object") {
            if (analytesComplex.complexValueAnalytes !== undefined) {
                let arrayLocalInputsAux = [];
                let valuesLocalAux = {};
                let analytesLocal = [...localAnalytes];
                analytesComplex.complexValueAnalytes.forEach(element => {
                    arrayLocalInputsAux.push(element);
                    analytesLocal = analytesLocal.filter(a => a.id_analyte !== element.id_analyte);
                    valuesLocalAux = {
                        ...valuesLocalAux,
                        [element.id_analyte]: {
                            id_analyte: element.id_analyte,
                            variable: element.variable,
                            valor: 1,
                            name_code: element.name + " [" + element.code + "]",
                            name: element.name,
                            code: element.code
                        }
                    }
                });
                setValuesLocal(valuesLocalAux)
                setArrayLocalInputs(arrayLocalInputsAux);
                setFormula(analytesComplex.formula);
                setLocalAnalytes(analytesLocal);
                setValidacionFormula({
                    status: true,
                    msg: ""
                });
            }
        }
    }, [analytesComplex])

    useEffect(() => {
        setExamActiveId(exam.id_exam);
    }, [exam])

    useEffect(() => {
        setLocalExams(exams);
        setSearch("");
    }, [exams])

    useEffect(() => {
        if (methodActive === "create") {
            setSearch("");
            setExamActiveId(exam.id_exam);
            setTypeComplex("local");
            setLocalAnalytes(analytesAvailables);
            setArrayLocalInputs([]);
            setFormula("");
        }
    }, [methodActive]);

    const stylesTd = {
        width: 200, whiteSpace: "break-spaces"
    }

    const [first, setFirst] = useState(0);
    const rows = 10; 

    const currentPageExams = localExams.slice(first, first + rows);

    const onPageChange = (e) => {
        setFirst(e.first);
    };

    useEffect(() => {
        setFirst(0);
    }, [search]);


    return (
        <div>
            <ModalHeader className="pb-1 pl-2 pr-2 text-white" style={{ backgroundColor: "#46afe5" }} >
                <span style={{ color: "white" }}>
                    Gestión de fórmula del analito : <b style={{ color: "white" }}>{name}</b>
                </span>
            </ModalHeader>

            <ModalBody className="pt-1 border-top border-light pb-0" style={{ backgroundColor: "#ffffff" }}>
                <Form role="form" onSubmit={null}>
                    <Row>
                        <FormGroup className={`mb-3 col-7`}>
                            <Row>
                                <Col sm="5" className="border-right border-light h-100vh overflow-auto p-3 bg-white shadow-sm">
                                    <h5 className="text-primary mb-3">
                                        Examen actual
                                    </h5>

                                    <ListGroup className="mb-4">
                                        <ListGroupItem
                                            style={{ cursor: "pointer" }}
                                            className={`list-group-item-action text-sm rounded ${examActiveId === exam.id_exam ? "active bg-primary text-white" : ""}`}
                                            onClick={() => handleLocal(exam.id_exam)}
                                        >
                                            <strong>{exam.name}</strong> <span className="text-muted">[{exam.abbreviation}]</span>
                                        </ListGroupItem>
                                    </ListGroup>

                                    <h5 className=" mb-2">
                                        Otros exámenes
                                    </h5>

                                    <FormGroup className="mb-3">
                                        <Input
                                             bsSize="sm"
                                            type="text"
                                            name="id_type_analyte"
                                            placeholder="Buscar examen..."
                                            value={search}
                                            onChange={handleSearch}
                                            className="rounded-pill"
                                        />
                                    </FormGroup>

                                    {/* <ListGroup>
                                        {localExams.length > 0 ? (
                                            localExams.map((obj, key) => (
                                                <ListGroupItem
                                                    key={key}
                                                    style={{ cursor: "pointer" }}
                                                    className={`list-group-item-action text-sm rounded mb-1 ${examActiveId === obj.id_exam ? "active bg-info text-white" : ""}`}
                                                    onClick={() => handleExternal(obj.id_exam)}
                                                >
                                                    <strong>{obj.name}</strong> <span className="text-muted">[{obj.code}]</span>
                                                </ListGroupItem>
                                            ))
                                        ) : (
                                            <p className="text-muted">0 exámenes encontrados</p>
                                        )}
                                    </ListGroup> */}

                                    <div>
                                        <ListGroup className="mb-2">
                                            {currentPageExams.length > 0 ? (
                                                currentPageExams.map((obj, key) => (
                                                    <ListGroupItem
                                                        key={key}
                                                        style={{ cursor: "pointer" }}
                                                        className={`list-group-item-action text-sm rounded mb-1 ${
                                                            examActiveId === obj.id_exam ? "active bg-info text-white" : ""
                                                        }`}
                                                        onClick={() => handleExternal(obj.id_exam)}
                                                    >
                                                        <strong>{obj.name}</strong> <span className="text-muted">[{obj.code}]</span>
                                                    </ListGroupItem>
                                                ))
                                            ) : (
                                                <p className="text-muted">0 exámenes encontrados</p>
                                            )}
                                        </ListGroup>

                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <Paginator
                                                first={first}
                                                rows={rows}
                                                totalRecords={localExams.length}
                                                onPageChange={onPageChange}
                                                template="PrevPageLink PageLinks NextPageLink"
                                                className="p-0"
                                                rowsPerPageOptions={[10, 20, 30]}
                                            />
                                        </div>
                                    </div>

                                </Col>

                                <Col sm="7" className="border-right border-light h-100vh overflow-auto p-3 bg-white shadow-sm">
                                    <h5 className='text-center'>Analitos disponibles</h5>
                                    {
                                        typeComplex === "local"
                                            ?
                                            <TableStriped
                                                notMaped={["valor", "variable", "name"]}
                                                cabeceras={["Analito", "Código"]}
                                                items={localAnalytes}
                                                methodsActions={true}
                                                methodsAbsolutes={
                                                    [
                                                        {
                                                            type: "linkId",
                                                            method: addLocalInput,
                                                            icon: "fa fa-plus",
                                                            backgroundColor: "#46afe5",
                                                            color: "#fff"
                                                        },
                                                    ]
                                                }
                                            />
                                            :

                                            <TableStriped
                                                notMaped={["valor", "variable", "name"]}
                                                cabeceras={["Analito"]}
                                                items={externalAnalytes}
                                                methodsActions={true}
                                                methodsAbsolutes={
                                                    [
                                                        {
                                                            type: "linkId",
                                                            method: addLocalInput,
                                                            icon: "fa fa-plus",
                                                            backgroundColor: "#46afe5",
                                                            color: "#fff"
                                                        },
                                                    ]
                                                }
                                            />
                                    }
                                </Col>
                            </Row>
                        </FormGroup>
                        <Col sm="5" className="border-left border-light px-4 py-3" style={{ maxHeight: "80vh", overflowY: "auto" }}>
                            <h5 className="text-primary text-center mb-3">Variables del Examen</h5>
                            {
                                arrayLocalInputs.length > 0 ? (
                                    arrayLocalInputs.map((obj) => (
                                        <div key={obj.id_analyte} className="mb-4 p-3 shadow-sm rounded bg-white">
                                            <h5 className="text-secondary mb-3">{obj.name_code}</h5>

                                            <Row form>
                                            <FormGroup className="col-6">
                                                <Label for={`variable-${obj.id_analyte}`} className="small font-weight-bold text-muted">
                                                Nombre de la variable
                                                </Label>
                                                <Input
                                                bsSize="sm"
                                                id={`variable-${obj.id_analyte}`}
                                                placeholder="Nombre de la variable"
                                                type="text"
                                                readOnly
                                                name={`${obj.id_analyte}`}
                                                autoComplete="off"
                                                onChange={(e) => handleInputLocal(e, "variable")}
                                                style={{ textTransform: "lowercase" }}
                                                defaultValue={obj.variable}
                                                />
                                            </FormGroup>

                                            <FormGroup className="col-6">
                                                <Label for={`valor-${obj.id_analyte}`} className="small font-weight-bold text-muted">
                                                Valor de prueba
                                                </Label>
                                                <Input
                                                bsSize="sm"
                                                id={`valor-${obj.id_analyte}`}
                                                placeholder="Valor de prueba"
                                                type="number"
                                                name={`${obj.id_analyte}`}
                                                autoComplete="off"
                                                onChange={(e) => handleInputLocal(e, "valor")}
                                                onBlur={validarVariables}
                                                defaultValue={1}
                                                />
                                            </FormGroup>
                                            </Row>
                                            </div>
                                    ))
                                ) : (
                                    <p className="text-muted">No hay variables definidas.</p>
                            )}

                            {arrayLocalInputs.length > 0 && (
                                <>
                                <hr />
                                <FormGroup>
                                    <Label for="formula" className="font-weight-bold"> Fórmula </Label>
                                    <Input bsSize="sm" id="formula" placeholder="Escribe la fórmula aquí" type="text" name="formula" value={formula} autoComplete="off" onChange={(e) => setFormula(e.target.value)} onFocus={validarVariablesLocales}/>
                                        {validacionFormula.status ? (
                                        <>
                                            <Button
                                            color="info"
                                            type="button"
                                            className="btn-sm btn-block mt-3"
                                            onClick={() => refreshFormComplex(valuesLocal, formula)}
                                            >
                                            Probar fórmula
                                            </Button>

                                            <p
                                            onClick={toggle}
                                            style={{ cursor: "pointer" }}
                                            className="text-info text-right small font-italic"
                                            >
                                            Tabla de funciones disponibles
                                            </p>

                                            <Collapse isOpen={isOpen}>
                                            <Table striped responsive size="sm" className="shadow-sm">
                                                <thead className="thead-light">
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Función</th>
                                                    <th>Descripción</th>
                                                    <th>Ejemplo</th>
                                                    <th>Resultado</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>Exponencial</td>
                                                    <td>Pow(x,y)</td>
                                                    <td style={{ maxWidth: "250px" }}>
                                                    Devuelve el valor de <i>x</i> elevado a la potencia <i>y</i>
                                                    </td>
                                                    <td>Pow(2,4)</td>
                                                    <td>16</td>
                                                </tr>
                                                <tr>
                                                    <td>Logaritmo10</td>
                                                    <td>Log10(x)</td>
                                                    <td>Devuelve el valor logaritmo base 10 de <i>x</i></td>
                                                    <td>Log10(100)</td>
                                                    <td>2</td>
                                                </tr>
                                                <tr>
                                                    <td>Promedio</td>
                                                    <td>Avg(x,y,z,...)</td>
                                                    <td>Devuelve el valor promedio de todos los argumentos dados</td>
                                                    <td>Avg(3,3,6)</td>
                                                    <td>4</td>
                                                </tr>
                                                <tr>
                                                    <td>Raíz cuadrada</td>
                                                    <td>Sqrt(x)</td>
                                                    <td>Devuelve la raíz cuadrada del valor dado</td>
                                                    <td>Sqrt(4)</td>
                                                    <td>2</td>
                                                </tr>
                                                </tbody>
                                            </Table>
                                            </Collapse>
                                        </>
                                        ) : (
                                        <small className="text-danger">{validacionFormula.msg}</small>
                                        )}

                                        {responseComplexText.validacion ? (
                                        <>
                                            <p className="mt-3 mb-1">
                                            <strong>Resultado de la prueba:</strong> {responseComplexText.result}
                                            </p>
                                            <Button
                                            type="button"
                                            onClick={() => preSavedFormComplex(valuesLocal, formula)}
                                            color="primary"
                                            className="btn-sm btn-block"
                                            >
                                            Confirmar fórmula
                                            </Button>
                                        </>
                                    ) : (
                                    <small className="text-danger">{responseComplexText.msg}</small>
                                    )}
                                </FormGroup>
                                </>
                            )}
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </div>
    )
}
